module.exports = __webpack_public_path__ + "img/location.02335d5f.svg";